// AUTOGENERATED
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const availabilityIsSymbol = {reflectSymbol: () => "availability"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const AvailabilityScheduleIsSymbol = {reflectSymbol: () => "AvailabilitySchedule"};
const AvailabilitySchedule = x => x;
const toFillFormTypeAvailabilit = {fillFormDataType: v => "unknown"};
const newtypeAvailabilitySchedu = {Coercible0: () => {}};
const hasFieldAvailabilitySched = dictHasField => dictHasField;
const eqAvailabilitySchedule = {eq: x => y => Restaumatic$dCalendar$dTypes$dAvailability.eqWeeklyAvailability.eq(x.availability)(y.availability) && x.name === y.name};
const genericAvailabilitySchedule = {to: x => x, from: x => x};
const showAvailabilitySchedule = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ availability: " + Restaumatic$dCalendar$dTypes$dAvailability.showWeeklyAvailability.show(v.availability) + ", name: " + Data$dShow.showStringImpl(v.name) + " " + "}"
      ]
    })(AvailabilityScheduleIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeAvailabilitySchedule = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(availabilityIsSymbol)(Restaumatic$dCalendar$dTypes$dAvailability.decodeWeeklyAvailability)(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeAvailabilitySchedule = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericAvailabilitySchedule)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(AvailabilityScheduleIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(nameIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(availabilityIsSymbol)({encodeWithOptions: v => Restaumatic$dCalendar$dTypes$dAvailability.encodeWeeklyAvailability.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeAvailabilitySchedule = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericAvailabilitySchedule)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AvailabilityScheduleIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(nameIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.readString
  })())(availabilityIsSymbol)({decodeWithOptions: v => Restaumatic$dCalendar$dTypes$dAvailability.decodeWeeklyAvailability1.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  AvailabilitySchedule,
  AvailabilityScheduleIsSymbol,
  availabilityIsSymbol,
  decodeAvailabilitySchedule,
  encodeAvailabilitySchedule,
  eqAvailabilitySchedule,
  genericAvailabilitySchedule,
  hasFieldAvailabilitySched,
  nameIsSymbol,
  newtypeAvailabilitySchedu,
  showAvailabilitySchedule,
  toFillFormTypeAvailabilit,
  unscrambleDecodeAvailabilitySchedule
};
